import { Injectable } from '@angular/core';
import { hotCallDetails } from '../models/hotCall.model';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  constructor() {}

  filterHotCalls(searchTerm: string, status: string,  hotCalls: hotCallDetails[]): hotCallDetails[] {
    return hotCalls.filter(call => {
      const matchesSearch = !searchTerm || call.kb.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesStatus = !status || call.ticketStatus.toLowerCase() === status.toLowerCase();
      return matchesSearch && matchesStatus;
    });
  }
  toggleSortOrder(data: hotCallDetails[], sortState: string): { sortedData: hotCallDetails[], sortState: 'normal' | 'asc' | 'desc' } {
    let sortedData = [...data];
    let newSortState: 'normal' | 'asc' | 'desc' = 'normal';

    switch (sortState) {
      case 'normal':
        newSortState = 'asc';
        sortedData = this.sortData(sortedData, 'asc');
        break;
      case 'asc':
        newSortState = 'desc';
        sortedData = this.sortData(sortedData, 'desc');
        break;
      case 'desc':
        sortedData = [...data];
        break;
    }
    return { sortedData, sortState: newSortState };
  }
  private sortData(data: hotCallDetails[], order: 'asc' | 'desc'): hotCallDetails[] {
    return data.sort((a, b) => {
      const dateA = new Date(a.crteOn);
      const dateB = new Date(b.crteOn)
      return order === 'asc' ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
    });
  }
}


